document.addEventListener("DOMContentLoaded", () => {
    const loading_spinner = document.querySelector(".loading__spinner");
    loading_spinner.classList.remove("hidden");
    setTimeout(() => loading_spinner.classList.add("hidden"), 1500);

    /* --------------------------------------------------------------------------
       MAIN FORM INITIALIZER
    -------------------------------------------------------------------------- */
    const initializeFormSteps = (shadow) => {
        const form = shadow.querySelector('form[data-testid="form"]');
        if (!form) return false;

        const billingLegend = Array.from(form.querySelectorAll("legend"))
            .find(l => l.textContent.trim() === "Company billing address");
        if (!billingLegend) return false;

        /* Split fields into Step 1 and Step 2 */
        const allFields = Array.from(form.querySelectorAll("div._formFieldContainer_1mxsl_5"));
        const firstStepFields = [];
        const secondStepFields = [];

        allFields.forEach(field => {
            if (billingLegend.compareDocumentPosition(field) & Node.DOCUMENT_POSITION_FOLLOWING) {
                secondStepFields.push(field);
            } else {
                firstStepFields.push(field);
            }
        });

        /* Collect elements after billing legend to hide on Step 1 */
        const elementsToHide = [];
        const collectElements = (el) => {
            if (!el || el === form) return;
            if (!elementsToHide.includes(el)) elementsToHide.push(el);
            Array.from(el.children).forEach(child => collectElements(child));
        };

        elementsToHide.push(billingLegend);
        let current = billingLegend;
        while (current && current.nextSibling) {
            current = current.nextSibling;
            if (current.nodeType === Node.ELEMENT_NODE) collectElements(current);
        }

        /* Known containers that appear after billing legend */
        [
            "._multiFieldLine_exnrn_1",
            "._nonMultineFieldLine_exnrn_11",
            "._fieldContainer_exnrn_16",
            "._selectContainer_12thd_6",
            "._formPhoneInputContainer_piv1u_6"
        ].forEach(selector => {
            form.querySelectorAll(selector).forEach(container => {
                if (billingLegend.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    elementsToHide.push(container);
                }
            });
        });

        // Hide all step 2 elements initially
        elementsToHide.forEach(el => {
            el.style.display = "none";
        });

        /* Buttons */
        const submitButton = form.querySelector('button[data-testid="btn-form-submit"]');
        if (submitButton) submitButton.style.display = "none";

        const doc = form.ownerDocument;

        const continueButton = doc.createElement("button");
        continueButton.type = "button";
        continueButton.textContent = "Continue";
        continueButton.className = submitButton?.className ?? "";

        const backButton = doc.createElement("button");
        backButton.type = "button";
        backButton.textContent = "Back";
        backButton.className = submitButton?.className ?? "_formSubmitButton_cit2d_96";
        backButton.style.background = "transparent";
        backButton.style.border = "1px solid #2D4E28";
        backButton.style.color = "#2D4E28";
        backButton.style.display = "none";

        /* T&Cs Checkbox */
        const tcsContainer = doc.createElement("label");
        tcsContainer.style.display = "none";
        tcsContainer.style.marginBottom = "10px";
        tcsContainer.style.alignItems = "center";
        tcsContainer.style.flexDirection = "row";

        const tcsCheckbox = doc.createElement("input");
        tcsCheckbox.type = "checkbox";
        tcsCheckbox.required = true;
        tcsCheckbox.style.marginRight = "8px";

        const tcsText = doc.createElement("span");
        tcsText.innerHTML = 'I accept the <a href="https://lot61-b2b.myshopify.com/pages/terms-conditions" target="_blank">Terms & Conditions</a>';

        tcsContainer.appendChild(tcsCheckbox);
        tcsContainer.appendChild(tcsText);

        /* Insert elements */
        if (submitButton?.parentNode) {
            submitButton.parentNode.insertBefore(continueButton, submitButton);
            submitButton.parentNode.insertBefore(tcsContainer, submitButton);
            submitButton.parentNode.insertBefore(backButton, submitButton);
        }

        /* Postal/City wrappers */
        const postalFields = () => shadow.querySelectorAll("div._multiFieldLine_exnrn_1");

        /* Step functions */
        const showStep1 = () => {
            form.dataset.currentStep = "1";
            firstStepFields.forEach(f => f.style.display = "");
            elementsToHide.forEach(e => e.style.display = "none");
            postalFields().forEach(el => el.style.display = "none");
            continueButton.style.display = "";
            backButton.style.display = "none";
            tcsContainer.style.display = "none";
            if (submitButton) submitButton.style.display = "none";
        };

        const showStep2 = () => {
            form.dataset.currentStep = "2";
            firstStepFields.forEach(f => f.style.display = "none");
            elementsToHide.forEach(e => e.style.display = "");
            postalFields().forEach(el => el.style.display = "");
            continueButton.style.display = "none";
            backButton.style.display = "";
            tcsContainer.style.display = "flex";
            if (submitButton) submitButton.style.display = "";
        };

        continueButton.addEventListener("click", showStep2);
        backButton.addEventListener("click", showStep1);

        /* T&Cs required */
        form.addEventListener("submit", (e) => {
            if (!tcsCheckbox.checked) {
                e.preventDefault();
                alert("Please accept the Terms & Conditions to continue.");
            }
        });

        /* Persistent observer for postal fields, only active on Step 1 */
        const observePostalCity = () => {
            const postalObserver = new MutationObserver(() => {
                if (form.dataset.currentStep === "1") {
                    postalFields().forEach(el => el.style.display = "none");
                }
            });
            postalObserver.observe(shadow, { childList: true, subtree: true });
        };

        observePostalCity();

        /* Initialize Step 1 */
        showStep1();
        return true;
    };

    /* --------------------------------------------------------------------------
       OBSERVE SHOPIFY EMBED
    -------------------------------------------------------------------------- */
    const container = document.querySelector(".shopify-app-block div");
    const observer = new MutationObserver((mutations, obs) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.tagName === "SHOPIFY-FORMS-EMBED") {
                    const shadow = node.shadowRoot;
                    if (shadow && initializeFormSteps(shadow)) {
                        obs.disconnect();
                        return;
                    }
                }
            }
        }
    });
    observer.observe(container, { childList: true, subtree: true });
});
